// components/nav-projects.jsx
import { Plus } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useState } from 'react';
import { CreateProjectModal } from '@/components/CreateProjectModal.jsx';

export function NavProjects({ setData }) {
  const [openCreate, setOpenCreate] = useState(false);

  return (
    <div className="space-y-2 w-full">
      {/* Header with Plus Button */}
      <div className="flex w-full items-center justify-between pt-2">
        <h4 className="text-sm font-medium">Projects</h4>
        <Button variant="ghost" size="icon" className="h-6 w-6" onClick={() => setOpenCreate(true)}>
          <Plus className="h-4 w-4" />
        </Button>
      </div>

      {/* Modals */}
      <CreateProjectModal open={openCreate} onOpenChange={setOpenCreate} setData={setData} />
    </div>
  );
}
